<template>
  <div class="container">
    <div class="content" :class="{ bgWhite: [0, 1, 2, 4].includes(tab), bgGray: [3, 5].includes(tab) }">
      <div class="nav">
        <div class="wrapper">
          <span class="item" v-for="(item, index) in navList" :key="index" :class="{ 'item_active': item.select }"
            @click="goPage(index, item)">
            {{ item.type }}
          </span>
        </div>
      </div>
    </div>

    <div class="fiedBox"></div>

    <!-- 渲染子路由页面 -->
    <router-view class="child-view"></router-view>

    <!-- 统一筛选栏组件 -->
    <filter-bar :initialCity="fullAddress" :areaOne="areaOne" @change="onFilterChange" />
  </div>
</template>

<script>
import FilterBar from './comps/filterBar.vue';
import API from "@/service/modules/complaintApis";
import util from "@/utils/common";

export default {
  name: 'ComplaintVisualization',
  components: {
    FilterBar
  },
  data() {
    return {
      fullAddress: this.$route.query.fullAddress || '云南省',
      areaOne: this.$route.query.areaOne,
      tab: 0,
      navList: [
        { type: '投诉件分析', select: true, path: `/complaint/visual/area` },
        { type: '处置情况分析', select: false, path: `/complaint/visual/disposalAnalysis` },
        { type: '游客分析', select: false, path: `/complaint/visual/touristAnalysis` },
      ],
      filterParams: {
        areaId: '',
        beginTime: '',
        endTime: '',
        channel: '',
        rule: '' // 修改为与后端及 Vuex 状态对齐的初始值
      }
    }
  },
  computed: {
    deptInfo() {
      return this.$store.state.complaint.deptInfo;
    }
  },
  created() {
    // 页面进入或浏览器刷新时，重置筛选器数据，避免带入旧数据
    this.$store.commit('complaint/resetVisualFilter');

    // 基础信息初始化逻辑，增加防御性判空，防止 txId 读取报错
    // if (!this.deptInfo || !this.deptInfo.txId) {
    this.getUserInfo();
    // }

    // 初始化 Vuex 状态：将 URL 里的 areaOne 同步，防止子组件挂载时由于默认值空导致的二次请求
    // 这样当子组件加载 mixin 时，immediate: true 拿到的初始值就是真实的 areaOne
    this.$store.commit('complaint/setVisualFilter', {
      areaId: this.areaOne || '',
      rule: '' // 后端规定：空字符串代表全部数据
    });
  },
  methods: {
    // 获取用户信息和部门信息
    getUserInfo() {
      API.common.user({}).then(res => {
        if (res.ret === 0) {
          let userInfo = Object.assign({}, res.data.userInfo, res.data);
          let deptInfo = (res.data.depts || [])[0] || {}; // 部门信息
          util.setJsonLocal('userInfoComplaint', res.data);
          this.$store.commit('complaint/setUserInfo', userInfo);
          this.$store.commit('complaint/setDeptInfo', deptInfo);
        }
      })
    },

    goPage(index, item) {
      if (this.tab === index) return; // 拦截相同路由跳转
      this.tab = index;
      this.$router.replace(item.path + `?fullAddress=${this.fullAddress || ''}&areaOne=${this.areaOne}`).catch(err => err); // catch 捕获冗余导航错误
      this.navList.forEach((nav, i) => {
        nav.select = i === index;
      });
    },

    // 监听筛选器变化，在此处刷新页面数据
    onFilterChange(data) {
      console.log('Visual: Filter Bar Change Observed ->', JSON.stringify(data));
      this.filterParams = { ...data };
      this.areaOne = data.areaId || '';
      if (data.areaName) this.fullAddress = data.areaName;

      // 关键：必须通过 {...data} 创建全新的对象引用，强制触发所有 Mixin 的 watch 深度比较
      this.$store.commit('complaint/setVisualFilter', { ...data });
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .content {
    width: 100%;
    padding: 14px 14px 6px 14px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;

    .nav {
      width: 100%;
      height: 40px;
      overflow-x: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .wrapper {
        white-space: nowrap;

        .item {
          display: inline-block;
          padding: 10px;
          font-size: 14px;
          color: #666;
        }

        .item_active {
          border-bottom: 2px solid @base-color;
          padding-bottom: 6px;
          color: @base-color;
          font-weight: 600;
          margin: 0 10px;
        }
      }
    }
  }

  .bgWhite {
    background-color: #fff;
  }

  .bgGray {
    background-color: #FBFBFB;
  }

  .fiedBox {
    height: 60px;
    flex-shrink: 0;
  }

  .child-view {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 80px; // 为底部的 filter-bar 留出空间

    ::v-deep .o-th,
    ::v-deep .o-td {
      text-align: left;
      -webkit-user-select: none;
      user-select: none;
      -webkit-touch-callout: none;
      -webkit-user-drag: none;
    }
  }
}
</style>
